<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({ name: 'MyUnit' });
</script>
<template>
    <div class="my-input-unit__wrapper">
        {{ useAppStore.currentPanel.pageUnit }}
    </div>
</template>

<script setup lang="ts">
import { useAppStoreHook as appStore } from '@myprint/design/stores/app';

;

const useAppStore = appStore();
</script>
